export default __webpack_public_path__ + "assets/af5421a473be3033faf9c759c96eba63.svg";